import { Line } from 'rc-progress'
import React from 'react'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CourseProgress = ({ courseModule, children }) => {
    const progress = Math.min(100, Math.max(0, Number(courseModule?.course_progress) || 0))
    const isCompleted = progress === 100

    return (
        <section className='rounded-2xl border border-white/10 bg-gradient-to-br from-[#17395A] to-[#102D47] p-4 shadow-[0_12px_32px_rgba(3,18,31,0.24)] sm:p-5' aria-label='Course progress'>
            <div className='flex items-center justify-between gap-4'>
                <div className='min-w-0'>
                    <p className='text-[11px] font-semibold uppercase tracking-[0.16em] text-[#8FB0CB]'>Current progress</p>
                    <h2 className='mt-1 text-lg font-semibold leading-6 text-white sm:text-xl'>
                        {isCompleted ? 'Course Completed!' : 'Continue where you left off'}
                    </h2>
                </div>
                {isCompleted && (
                    <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#7FC241]/15 text-lg text-[#9AE05E]' aria-label='Completed'>
                        <FontAwesomeIcon icon={faCheck} aria-hidden='true'/>
                    </div>
                )}
            </div>
            {!isCompleted && (
                <>
                    <div className='mt-4'>
                        <Line
                            percent={progress}
                            strokeColor='#54A3F5'
                            trailColor='#274B6A'
                            strokeWidth={3}
                            trailWidth={3}
                            strokeLinecap='round'
                        />
                    </div>
                    <div className='mt-2 flex justify-between text-xs font-medium text-[#8FB0CB]'>
                        <span>{progress}% completed</span>
                        <span>{100 - progress}% remaining</span>
                    </div>
                </>
            )}
            {children}
        </section>
    )
}

export default CourseProgress
